<template>
	<bsh-modal 
		titulo="Nova Tag"
		:name="name">
		<template v-slot:default>
	        <tag-form
				:dados="dados"
				:name="name"
				:errors="errors">
			</tag-form>
	    </template>
	    <template v-slot:footer>
        	<button 
				ref="btnRequest"
        		type="button" 
        		class="btn btn-primary" 
        		@click="create">
        		Salvar
        	</button>
        </template>
    </bsh-modal>
</template>

<script>
	import Tag from "./../../models/Tag.js";
	export default {
		data(){
			return {
				dados: new Tag(),
				name: 'create_tag',
				errors: []
			}
		}, 
		methods: {
			create(){
				this.$btnFunctions.disableToggle(this.$refs.btnRequest, true)
	            axios.post(this.$url+'/api/adm/tags/store', (this.dados))
	            .then(response => {
	            	$('#'+this.name).modal('hide')
	            	this.$bshMessage.show(response.data.message, response.data.type)
	              	this.dados = new Tag()
	              	this.$emit('reload')
					this.$btnFunctions.disableToggle(this.$refs.btnRequest, false)
	            })
	            .catch(error => {
					this.errors = error.response.data.errors
					this.$btnFunctions.disableToggle(this.$refs.btnRequest, false)
				});
        	},
		},
	}
</script>